import { CitationMap, FootnoteData, FootnotesMap } from "./types";
import { RagCitation } from "fe-common/graphql";

export function rearrangeCitations(ruleValues: RagCitation[]) {
  if (!ruleValues) return null;
  //map citation id to citation
  const citationsMap: CitationMap = ruleValues.reduce((accMap, rv) => {
    if (!rv.ruleCitations) {
      console.log("No ruleCitations for rule:", rv);
      return accMap;
    }
    rv.ruleCitations?.forEach((rc) => {
      if (rc) {
        if (!accMap.has(rc.id)) {
          accMap.set(rc.id, {
            title: rc.title,
            url: rc.url,
            vancouver: rc.vancouver,
            pubmedID: rc.pubmedID,
          });
        }
      }
    });

    return accMap;
  }, new Map());

  //map citation index to ruleValue index
  const citationIndexesSet = Array.from(citationsMap.keys());
  const footnotesMap: FootnotesMap = new Map();
  ruleValues.forEach((rv, rvIndex) => {
    const citationIndexes: FootnoteData[] = rv.ruleCitations
      .filter((rc) => rc)
      .map((rc) => ({
        index: citationIndexesSet.indexOf(rc.id) + 1,
        id: rv.rvids[0],
        title: rv.text,
      }))
      .filter((fn) => fn.index > 0);

    if (citationIndexes.length > 0) {
      footnotesMap.set(rvIndex + 1, citationIndexes);
    }
  });

  return { citationsMap, footnotesMap };
}

export function convertToMarkdownList(inputString: string = "") {
  // Split the input string into lines
  const lines = inputString.split(/\r?\n/);
  let markdownList = "";

  lines.forEach((line, index) => {
    // Skip empty lines
    if (line.trim() !== "") {
      markdownList += `${index + 1}. ${line.trim()}\n`;
    }
  });

  return markdownList;
}

export function escapeMarkdown(str: string) {
  return str.replace(/([#*_~|'`])/g, "\\$1");
}

export function addAnnotations(
  str: string,
  footNotes: FootnotesMap,
  withDebug = false,
): string {
  if (!str) return "";
  const parts = str.split(/( \^\d+(?: \^\d+)*)/g); //split by footnote groups
  if (!parts.length || !footNotes) return str;

  const converted = parts.map((part, partIndex) => {
    if (partIndex % 2 === 0) return part; //text

    //get rule numbers
    const ruleNums = part.split(/ \^(\d+)/g).filter(
      (r) => !isNaN(parseInt(r)) && footNotes.has(parseInt(r)), //filter out invalid footnotes/no citation defined
    );

    //replace rule numbers with citations
    const citations = ruleNums.flatMap((ruleNum) =>
      footNotes.get(parseInt(ruleNum)),
    );

    //make sure the citations are unique and sort by citation index
    const sortedCitations = Array.from(
      new Map(
        citations.map((citation: FootnoteData) => [citation.index, citation]),
      ).values(),
      (citation) => ({
        ...citation,
      }),
    ).sort((a, b) => a.index - b.index);
    return sortedCitations
      .map(
        (fn) =>
          `[[${fn.index}]](${fn.index} '${escapeMarkdown(fn.title)}${
            withDebug ? `\n(${fn.id})` : ""
          }')`,
      )
      .join("");
  });
  return converted.join("");
}
